import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Checkbox } from '../../components/ui/checkbox';
import { DollarSign } from 'lucide-react';
import SourceCombobox from '../common/SourceCombobox';
import { commissionTypeOptions } from '../../constants/commissionRuleOptions';
import {
  CommissionRulesData,
  CommissionRulesProps,
} from '../../constants/commissionRuleOptions';
import {
  preventInvalidNumberInput,
  preventInvalidNumberPaste,
} from '../../utils/validationMessages';

const CommissionRules = ({ data, onChange }: CommissionRulesProps) => {
  const handleChange = (field: keyof CommissionRulesData, value: any) => {
    onChange({ ...data, [field]: value });
  };

  const selectedCommissionType =
    commissionTypeOptions.find(option => option.value === data.commissionType)
      ?.label || '';

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-500/10 rounded-lg">
            <DollarSign className="h-5 w-5 text-blue-500" />
          </div>
          <div>
            <CardTitle>Commission Rules</CardTitle>
            <CardDescription>
              Configure commission structure and rates
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="commission-type">Commission Type</Label>
          <SourceCombobox
            id="commission-type"
            items={commissionTypeOptions.map(option => option.label)}
            placeholder="Select commission type"
            value={selectedCommissionType}
            onChange={value => {
              const commissionType = commissionTypeOptions.find(
                option => option.label === value
              );
              if (commissionType) {
                handleChange('commissionType', commissionType.value);
              }
            }}
            emptyText="No commission types found."
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="commission-rate">Commission Rate (%)</Label>
          <Input
            id="commission-rate"
            type="number"
            placeholder="Enter commission rate"
            value={data.commissionRate}
            onKeyDown={preventInvalidNumberInput}
            onPaste={preventInvalidNumberPaste}
            onChange={e =>
              handleChange('commissionRate', parseFloat(e.target.value) || 0)
            }
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="minimum-payout">Minimum Payout Amount</Label>
          <Input
            id="minimum-payout"
            type="number"
            placeholder="Enter minimum amount"
            value={data.minimumPayoutAmount}
            onKeyDown={preventInvalidNumberInput}
            onPaste={preventInvalidNumberPaste}
            onChange={e =>
              handleChange(
                'minimumPayoutAmount',
                parseFloat(e.target.value) || 0
              )
            }
          />
        </div>
        <div className="flex items-center gap-2 pt-2">
          <Checkbox
            id="negative-balance"
            checked={data.negativeBalanceProtection}
            onChange={e =>
              handleChange('negativeBalanceProtection', e.target.checked)
            }
          />
          <Label htmlFor="negative-balance" className="text-sm">
            Allow negative balance protection
          </Label>
        </div>
      </CardContent>
    </Card>
  );
};

export default CommissionRules;
